export const NOTE_PLACEHOLDER_MAX = 14

export function normalizeNotePlaceholder(value) {
  return String(value ?? '').trim()
}

export function countNotePlaceholderChars(value) {
  return [...normalizeNotePlaceholder(value)].length
}
